<template>
    <breadcrumbs v-if="kpi?.id" :text="kpiName" />
    <v-tabs v-model="productTab" color="primary">
        <v-tab :value="'tab-' + 'information'">{{ $t('information') }}</v-tab>
        <v-tab :value="'tab-' + 'bi'">
            <v-icon start>mdi-finance</v-icon>
            {{ $t('bi') }}
        </v-tab>
    </v-tabs>
    <v-tabs-window v-model="productTab">
        <v-tabs-window-item value="tab-information">
            <KpiForm v-if="kpi?.id" :kpi-id="kpi?.id" :kpi="kpi" class="pt-5" @save="updateData" />
        </v-tabs-window-item>
        <v-tabs-window-item value="tab-bi">
            <KpiBiTable v-if="kpi?.id" ref="biTable" :kpi-id="kpi?.id" class="pt-5" />
        </v-tabs-window-item>
    </v-tabs-window>
</template>

<script setup lang="ts">
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'
    import KpiForm from '~/components/kpi/KpiForm.vue'
    import KpiBiTable from '~/components/kpi/KpiBiTable.vue'

    const isLoading = ref<boolean>(false)
    const kpiId = ref(null)
    const kpi = ref(null)
    const productTab = ref()
    const localized = useLocalized()
    const kpiName = ref<string>('')
    const biTable = ref(null)

    const route = useRoute()
    const router = useRouter()
    const app = useNuxtApp()

    onMounted(async () => {
        productTab.value = 'tab-information'
        kpiId.value = route.params.id
        const queryTab = route?.query?.productTab as string
        if (queryTab) {
            productTab.value = queryTab
            await router.replace({query: {}})
        }
        if (kpiId.value) await loadData()
        kpiName.value = localized(kpi.value.name)
    })

    async function loadData(): Promise<void> {
        try {
            isLoading.value = true
            const {
                apiKpis: [_kpi],
            } = await app.$api.kpi.get({id: kpiId.value, locale: 'all'})
            kpi.value = _kpi
        } catch (e) {
            kpi.value = null
        } finally {
            isLoading.value = false
        }
    }

    const updateData = data => {
        kpi.value = data
        kpiName.value = localized(kpi.value.name)
        if (biTable.value) biTable.value.loadData()
    }
</script>
